import { useEffect, useRef, useState } from "react";
import "./stepper.scss";

const Stepper = ({ stepConfig = [], incrementStep, handleStepperClick, onStepChange }: any) => {
  const [currentStep, setCurrentStep] = useState<number>(incrementStep ?? 1);
  const [margins, setMargins] = useState({
    marginLeft: 0,
    marginRight: 0,
  });
  const stepRef = useRef<any>([]);

  useEffect(() => {
    setMargins({
      marginLeft: stepRef.current[0]?.offsetWidth / 2,
      marginRight: stepRef.current[stepConfig.length - 1]?.offsetWidth / 2,
    });
  }, [stepRef, stepConfig]);

  useEffect(() => {
    setCurrentStep(incrementStep);
  }, [incrementStep]);

  useEffect(() => {
    if (onStepChange) {
      onStepChange(currentStep);
    }
  }, [currentStep]);

  const ActiveComponent = stepConfig[currentStep - 1]?.Component;
  const calculateProgressBarWidth = () => {
    return ((currentStep - 1) / (stepConfig.length - 1)) * 100;
  };

  const handleStepClick = (stepIndex: number) => {
    setCurrentStep(stepIndex + 1);
  };

  if (!stepConfig.length) {
    return <></>;
  }

  return (
    <>
      <div className="stepper-container">
        {stepConfig.map((step: any, index: number) => {
          return (
            <div
              key={step.name}
              ref={(el) => (stepRef.current[index] = el)}
              className={`step ${currentStep > index + 1 ? "complete" : ""} ${currentStep === index + 1 ? "active" : ""}`}
            >
              <div
                className="step-number"
                style={{
                  cursor: currentStep > index && handleStepperClick ? "pointer" : "default",
                }}
                onClick={() => (currentStep > index && handleStepperClick) && handleStepClick(index)}
              >
                <div className="step-number1">
                  {currentStep > index + 1 && (
                    <span className="right-img">&#10003;</span>
                  )}
                </div>
              </div>
              <div className="step-name">{step.name}</div>
            </div>
          );
        })}
        <div
          className="progress-bar"
          style={{
            width: `calc(100% - ${margins.marginLeft + margins.marginRight}px)`,
            marginLeft: margins.marginLeft,
            marginRight: margins.marginRight,
          }}
        >
          <div
            className="progress"
            style={{ width: `${calculateProgressBarWidth()}%` }}
          ></div>
        </div>
      </div>
      <ActiveComponent />
    </>
  );
};

export default Stepper;
